// extracted by mini-css-extract-plugin
export default {"talkUploadPreviewContainer":"GroupUploadPreview_talkUploadPreviewContainer__enHjy","talkUploadPreview":"GroupUploadPreview_talkUploadPreview__s17Av"};